export enum CustomerType {
  TP, RSO, CRC
}
